import { Recipe } from './Recipe';
import { Recipes } from './Recipes';

export const recipesRoutes = [
  { index: true, element: <Recipes /> },
  { path: ':recipeId', element: <Recipe /> },
];
